<template>
  <div class="signup">
    <h1 class="signup__heading signup__heading--hide-sm">Welcome to ePayLater</h1>
    <form class="signup__form" @submit.prevent="mobile">
      <p class="signup__form__label">Enter your mobile number</p>
      <div class="signup__form__text-fieldset">
        <p class="signup__form__text-fieldset__country-code">+91</p>
        <input
          class="signup__form__text-field signup__form__text-field--code"
          type="tel"
          name="mobile"
          required
          minlength="10"
          maxlength="10"
          pattern="[0-9]{10}"
          v-model="params.mobile"
          v-numericOnly
          v-focus
        />
      </div>
      <div
        class="signup__form__text-field--mb-12"
        v-if="showReferralCode && $route.name==='Signup'"
      >
        <input
          class="signup__form__text-field"
          placeholder="Referral Code"
          type="text"
          name="referral_code"
          maxlength="15"
          v-model="params.referralCode"
        />
        <Message v-show="message.fieldName==='referral_code'" :message="message" />
      </div>
      <button
        class="signup__form__referral-code"
        id="referral_code_button"
        type="button"
        v-else-if="!showReferralCode && $route.name==='Signup'"
        @click="showReferralCode=true"
      >Have a Referral Code?</button>
      <label for="tnc" v-if="$route.name==='Signup'" class="signup__form__label--alternate">
        <input
          class="signup__form__checkbox"
          type="checkbox"
          name="tnc"
          id="tnc"
          v-model="agreeTerms"
          required
          checked
        />
        <span>
          I agree to ePayLater's
          <a
            target="_blank"
            href="https://epaylater.in/term.html"
            class="signup__form__label--alternate__link"
          >terms and conditions</a>
        </span>
      </label>
      <template v-if="message && message.showModal">
        <Overlay @on-click="unsetErrors" />
        <ConfirmationModal :message="message">
          <template v-slot:close-button>
            <button class="close-button" type="button" @click="unsetErrors">
              <img src="../../static/images/cross.svg" alt="Close Button" />
            </button>
          </template>
          <ActionButton
            v-slot:default
            v-for="(action,index) in message.actions"
            :key="index"
            @click="action.method"
            :title="action.title"
            :className="action.isPrimary?'':'action-button--alternate'"
            type="button"
          />
        </ConfirmationModal>
      </template>
      <ActionButton
        :disabled="(!(params.mobile&&params.mobile.length===10)) || !agreeTerms"
        title="Continue"
      />
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";
import Message from "../components/SignupInfoMessage";
import Overlay from "../components/Overlay";
import ConfirmationModal from "../components/ConfirmationModal";

export default {
  name: "Sign-Up",
  data() {
    return {
      params: {
        mobile: undefined,
        referralCode: undefined,
        recaptcha: undefined,
        utmCampaign: this.$route.path.utmCampaign,
        utmMedium: this.$route.path.utmMedium,
        utmSource: this.$route.path.utmSource
      },
      showReferralCode: false,
      agreeTerms: true,
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined
      }
    };
  },
  components: { ActionButton, Message, Overlay, ConfirmationModal },
  computed: {
    ...mapGetters(["loggedIn"])
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: this.$route.name.toUpperCase()
    });
  },
  created() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", () => {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    mobile() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "MOBILE_NUMBER_ENTERED",
        propertyName: "VIEW",
        propertyValue: this.$route.name.toUpperCase()
      });
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "MOBILE_NUMBER_ENTERED",
        propertyName: "REFERRAL_CODE",
        propertyValue: this.params.referralCode
          ? this.params.referralCode
          : "NO_REFERRAL"
      });
      this.$store
        .dispatch("generateRecaptcha", { action: "mobile" })
        .then(token => {
          this.params.recaptcha = token;
          this.$store
            .dispatch("mobile", this.params)
            .then(response =>
              response.signupRequired
                ? this.$router.push({ name: "Verify OTP" })
                : this.$router.push({
                    name: "Login Verify OTP",
                    query: { redirect: this.$route.query.redirect }
                  })
            )
            .catch(err => {
              if (err.status === 401) {
                this.$router.push({ name: "Signup" });
              } else {
                if ((err.data.eplErrorCode = "EPL2005")) {
                  this.$router.push({ name: "Signup Blocked" });
                } else {
                  this.message = {
                    type: "warning",
                    className: "message--error",
                    fieldName: "generic",
                    value: err.data.message,
                    showModal: true,
                    actions: [
                      {
                        title: "Ok",
                        method: () => this.unsetErrors(),
                        isPrimary: true
                      }
                    ]
                  };
                }
              }
            });
        })
        .catch(err => console.error(err));
    },
    unsetErrors() {
      this.message = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.signup {
  max-width: 30rem;
  justify-self: center;
  &__row {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
  }
  &__heading {
    font-size: 1.8rem;
    font-weight: 500;
    color: var(--gray-2);
    margin-bottom: 0.5rem;
    text-align: center;
    position: relative;
    line-height: 2.8rem;
    @media only screen and (min-width: 640px) {
      margin-bottom: 1rem;
      font-size: 2.2rem;
    }
    &__label {
      font-size: 1.4rem;
      color: var(--gray-3);
      display: block;
      margin-top: 1.6rem;
      font-weight: 300;
      text-align: center;
    }
    &--hide-sm {
      display: none;
      @media only screen and (min-width: 640px) {
        display: block;
      }
    }
  }
  &__form {
    display: grid;
    justify-content: center;
    margin-top: 3rem;
    &__label {
      font-size: 1.8rem;
      font-weight: 500;
      color: var(--gray-2);
      margin-bottom: 1rem;
      @media only screen and (min-width: 640px) {
        text-align: center;
      }
      &--alternate {
        font-size: 1.6rem;
        color: var(--gray-3);
        display: flex;
        align-items: flex-start;
        &__link {
          color: var(--primary-color);
          text-decoration: none;
        }
        &--text-center {
          display: block;
          text-align: center;
        }
      }
      &--text-center {
        text-align: center;
      }
    }
    &__referral-code {
      font-size: 1.6rem;
      color: var(--primary-color);
      background: transparent;
      border: none;
      margin-bottom: 3rem;
    }
    &__text-field {
      border: solid 0.06rem var(--gray-4);
      display: block;
      padding: 1rem;
      font-size: 2.2rem;
      width: 100%;
      color: var(--gray-2);
      border-radius: 0.4rem;
      text-align: center;
      &--mb-12 {
        margin-bottom: 3rem;
      }
      &--hide {
        display: none;
      }
      &--code {
        max-width: 24.8rem;
      }
      &set {
        position: relative;
        margin-bottom: 3rem;
        display: flex;
        align-items: center;
        &__country-code {
          font-size: 2.2rem;
          color: var(--gray-2);
          padding: 1rem;
          margin-bottom: 0;
          border-radius: 0.4rem;
          border: solid 0.6px #79899f;
          height: 100%;
          display: flex;
          align-items: center;
          opacity: 0.4;
        }
      }
      &::placeholder {
        font-size: 1.8rem;
        color: var(--gray-4);
      }
      &:focus {
        border: 0.1rem solid var(--primary-color);
        outline: none;
      }
    }
    &__checkbox {
      margin: 0;
      margin-right: 0.5rem;
    }
    &__submit {
      border-radius: 0.6rem;
      background: var(--primary-color);
      color: var(--white);
      font-size: 1.6rem;
      font-weight: 900;
      padding: 1.4rem;
      width: 100%;
      margin-bottom: 5.5rem;
      cursor: pointer;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        margin-left: 1rem;
      }
    }
    &__referral {
      font-size: 1.8rem;
      color: var(--primary-color);
      background: transparent;
      outline: none;
      border: none;
      box-shadow: none;
      cursor: pointer;
      text-align: center;
      width: 100%;
    }
  }
}
.action-button {
  max-width: 30rem;
}
.close-button {
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue